'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _templateObject = _taggedTemplateLiteral(['\n  border-bottom: 1px solid;\n  border-bottom-color: ', ';\n  font-family: ', ';\n  font-weight: ', ';\n  text-align: ', ';\n\n  @media print {\n    border-bottom: 1px solid ', ';\n  }\n'], ['\n  border-bottom: 1px solid;\n  border-bottom-color: ', ';\n  font-family: ', ';\n  font-weight: ', ';\n  text-align: ', ';\n\n  @media print {\n    border-bottom: 1px solid ', ';\n  }\n']),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _styles = require('../styles'),
    _themes = require('../themes'),
    _propTypes3 = require('../propTypes');

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Styled = {
  div: {}
},
    cellStyles = (0, _styles.css)(_templateObject, (0, _themes.getStyle)('TableDataCell_borderColor'), (0, _themes.getStyle)('TableDataCell_fontFamily'), (0, _themes.getStyle)('TableDataCell_fontWeight'), function (props) {
  return props.numeric ? 'right' : 'left';
}, function (props) {
  return props.theme.vstui.color.black;
});
Styled.td = _styledComponents2.default.td.withConfig({
  displayName: 'TableDataCell__td'
})(['', ';padding:13px 20px;background:', ';color:', ';font-size:', ';line-height:1.36;vertical-align:top;@media print{padding:0 5px;color:', ';font-size:', ';}'], cellStyles, function (props) {
  return props.sc.rowHover ? props.sc.secondary ? (0, _themes.getStyle)('TableDataCell_backgroundColor_secondary_hover') : (0, _themes.getStyle)('TableDataCell_backgroundColor_primary_hover') : (0, _themes.getStyle)('TableDataCell_backgroundColor');
}, (0, _themes.getStyle)('TableDataCell_color'), function (props) {
  return props.theme.vstui.rem((0, _themes.getStyle)('TableDataCell_fontSize')(props));
}, function (props) {
  return props.theme.vstui.color.black;
}, function (props) {
  return props.theme.vstui.typography.pxToRem(props.theme.vstui.typography.fontSize - 1);
});

var TableDataCell = function (_Component) {
  function TableDataCell() {
    return _classCallCheck(this, TableDataCell), _possibleConstructorReturn(this, (TableDataCell.__proto__ || Object.getPrototypeOf(TableDataCell)).apply(this, arguments));
  }

  return _inherits(TableDataCell, _Component), _createClass(TableDataCell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          numeric = _props.numeric,
          rowHover = _props.rowHover,
          secondary = _props.secondary,
          theme = _props.theme;
      return _react2.default.createElement(Styled.td, {
        sc: {
          numeric: numeric,
          rowHover: rowHover,
          secondary: secondary
        },
        theme: theme
      }, this.props.children);
    }
  }]), TableDataCell;
}(_react.Component);

TableDataCell.propTypes = {
  children: _propTypes2.default.node,
  numeric: _propTypes2.default.bool,
  rowHover: _propTypes2.default.bool,
  secondary: _propTypes2.default.bool,
  theme: _propTypes3.themeShape
}, TableDataCell.defaultProps = {
  theme: (0, _themes.createTheme)()
}, TableDataCell.displayName = 'TableDataCell';
var TableDataCellWithTheme = (0, _themes.withTheme)(TableDataCell);
TableDataCellWithTheme.WrappedComponent = TableDataCell, exports.default = TableDataCellWithTheme;